<script setup lang="ts">
import {
  PhxsgHeading as PhxsgCoreHeading,
  PhxsgHeadingProps as PhxsgCoreHeadingProps,
} from '@sg-core/src/View/Components/Atoms/Heading';

type HeadingColor = 'primary' | 'secondary' | 'tertiary';

type PhxsgHeadingProps = Omit<PhxsgCoreHeadingProps, 'color'> & {
  color?: HeadingColor;
};

const { color = 'primary' } = defineProps<PhxsgHeadingProps>();
</script>

<template>
  <PhxsgCoreHeading
    :class="{
      [`phxsg-text--${color}`]: color,
    }"
    v-bind="$props"
  >
    <slot />
  </PhxsgCoreHeading>
</template>

<style src="../Text/text.css" />
